import { render, staticRenderFns } from "./designInst_.vue?vue&type=template&id=0f41f4cc&scoped=true"
import script from "./designInst_.vue?vue&type=script&lang=js"
export * from "./designInst_.vue?vue&type=script&lang=js"
import style0 from "./designInst_.vue?vue&type=style&index=0&id=0f41f4cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f41f4cc",
  null
  
)

export default component.exports